module.exports = __webpack_public_path__ + "img/8.a8d92393.jpg";